import React, { useEffect, useRef, useState } from 'react'
import cx from 'classnames'
import { Scroll } from 'front-end-core/services/WindowService'
import { getBoundingClientRect, scrollTo } from 'front-end-core/helpers/document'
import useObservable from 'front-end-core/hooks/useObservable'
import { searchResultExpandCallback as expandCallback, selectCallback } from 'services/CurrentAwarenessService'
import CaKeyPicksContainer from 'redux/containers/components/ca/CaKeyPicksContainer'
import CaAccordionSkeletonContainer from 'redux/containers/pages/currentawareness/CaAccordionSkeletonContainer'
import ConnectedCaAccordion from 'pages/currentawareness/ConnectedCaAccordion'
import Title from 'components/ca/Title'
import Left from './Left'

const CurrentAwarenessMain = ({
  fromDate,
  toDate,
  isAccordionLoaded,
  isLargeDesktop,
  headerHeight,
  browser,
  isMobile,
  pageId,
  ...props
}) => {
  const contentViewRef = useRef()
  const scrollRef = useRef()
  const [fixed, setFixed] = useState(false)
  const { scrollMain } = useObservable(Scroll)

  // scroll to content on filter change
  useEffect(() => {
    scrollTo({ pageId, element: contentViewRef.current, useWindowScrollTo: isMobile })
  }, [fromDate, toDate, contentViewRef])

  // make the filter panel sticky once you start scrolling main content
  useEffect(() => {
    if (!isLargeDesktop) {
      fixed && setFixed(false)
      return
    }
    const { top } = getBoundingClientRect(scrollRef.current)
    setFixed((top - headerHeight) <= 0)
  }, [scrollRef, scrollMain, headerHeight])

  return (
    <div className='layout-width-constraint' ref={contentViewRef}>
      <div>
        <CaKeyPicksContainer />
        <Title />
      </div>
      <div>
        <div className='flex' ref={scrollRef}>
          <div className={cx({ mr6: isLargeDesktop })}>
            <div
              style={fixed ? { top: headerHeight } : {}}
              className={cx('ca-left-width bg-white grow-0 shrink-0', {
                dn: !isLargeDesktop,
                fixed
              })}
            >
              <Left {...{ fromDate, toDate }} />
            </div>
          </div>
          <div className={cx('w-100 bg-ghost-grey', { 'ml14 pl10': fixed && browser.name !== 'safari' })}> {/* Spacing required when position is fixed */}
            {!isAccordionLoaded && <CaAccordionSkeletonContainer />}
            <div className={cx({ dn: !isAccordionLoaded })}>
              <ConnectedCaAccordion {...{ fromDate, toDate, ...props, expandCallback, selectCallback }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CurrentAwarenessMain
